import { ScrollArea, Skeleton } from '@mantine/core';
import { Empty, Pagination } from 'antd';
import HeaderSearchFilter from 'components/Organisms/DetailGiftCategory/HeaderSearchFilter';
import ListGiftCategory from 'components/Organisms/DetailGiftCategory/ListGiftCategory';
import { optionsFilter, provinceList } from 'constants/index';
import { getAuth, getLocalGiftGroupCodeFilter, isPending } from 'functions';
import { debounce } from 'lodash';
import { getProfileByC } from 'model/actions/LoyaltyAccountInfoAction';
import { getListMyGift } from 'model/services/LoyaltyGiftService';
import * as qs from 'query-string';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';
import { useLocation } from 'react-router-dom';
import { getListMyGiftGroupStore } from 'model/services/LoyaltyAccountInfoService';

export const defaultIcon = '/assets/images/loyalty/pc/gift/book.png';

const DetailGiftCategory = () => {
  const dispatch = useDispatch();
  const { search: searchParams } = useLocation();
  // @ts-ignore
  const profileUser = useSelector((state) => state.LoyaltyAccountInfoReducer.profilebyc);

  const [listGift, setListGift] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 24,
    total: 10,
  });
  const [filter, setFilter] = useState({
    cityCode: provinceList[0].value,
    sort: optionsFilter[0].value,
  });
  const [search, setSearch] = useState('');

  const handldePagiantionChange = (pageCurrent, pageSize) => {
    setPagination((pre) => {
      return {
        ...pre,
        pageSize,
        current: pageCurrent,
      };
    });
  };
  const handleChangeFilter = useCallback(
    (value, key) => {
      setFilter((prev) => {
        return { ...prev, [key]: value };
      });
    },
    [filter]
  );

  const getListGiftFunc = (payload) => {
    setIsLoading(true);
    // if (qs.parse(searchParams).code === 'hottest') {
    //   const hottest = JSON.parse(localStorage.getItem('hottest'));
    //   setListGift(hottest?.obj || []);
    //   setPagination((prev) => {
    //     return {
    //       ...prev,
    //       total: hottest?.totalRecords,
    //     };
    //   });
    //   setIsLoading(false);
    // } else {
    //   getListMyGift(payload)
    //     .then((res) => {
    //       console.log(res?.result);
    //       setListGift(res?.result?.items || []);
    //       setPagination((prev) => {
    //         return {
    //           ...prev,
    //           total: res?.result?.totalCount,
    //         };
    //       });
    //       setIsLoading(false);
    //     })
    //     .catch((err) => {
    //       setIsLoading(false);
    //     });
    // }
    if (qs.parse(searchParams).code === 'hottest') {
      const giftGroupCodeFilter = getLocalGiftGroupCodeFilter()
      const auth = getAuth();
            getListMyGift({
        memberCode: auth?.username,
        giftGroupCodeFilter: giftGroupCodeFilter,
        skipCount: pagination.pageSize * (pagination.current - 1),
        maxResultCount: pagination.pageSize,
        // statusFilter: 'A',
        sorting: payload.sorting,
        titleCity: payload.titleCity,
        giftNameFilter: payload.giftNameFilter
      })
      .then((res) => {
        setListGift(res?.obj || []);
        setPagination((prev) => {
          return {
            ...prev,
            total: res?.totalRecords,
          };
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
    } else {
      getListMyGift(payload)
        .then((res) => {
          console.log(res?.o);
          setListGift(res?.obj|| []);
          setPagination((prev) => {
            return {
              ...prev,
              total: res?.totalRecords,
            };
          });
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  const deboundSearch = useRef(
    debounce((valueSearch) => {
      setSearch(valueSearch);
    }, 1000)
  ).current;

  useEffect(() => {
    if (!profileUser.obj.code) {
      const auth = getAuth();
      dispatch(getProfileByC(auth.username));
    }
  }, [profileUser]);

  useEffect(() => {
    return () => {
      deboundSearch.cancel();
    };
  }, [deboundSearch, search]);

  useEffect(() => {
    if (profileUser.obj.code) {
      const payload = {
        giftCategoryCodeFilter: qs.parse(searchParams).code,
        maxResultCount: pagination.pageSize,
        memberCode: profileUser.obj.code,
        giftNameFilter: search.toLowerCase().trim(),
        skipCount: pagination.pageSize * (pagination.current - 1),
        // sorting: Number(filter.sort) === 1 ? 'requiredCoin ASC' : 'requiredCoin DESC',
        sorting: Number(filter.sort),
        titleCity: filter.cityCode,
      };
      getListGiftFunc(payload);
    }
  }, [profileUser.obj.code, pagination.current, pagination.pageSize, filter, search]);

  const processBar = isPending(isLoading);

  return (
    <div className='bg-white lg:bg-transparent'>
      {processBar}
      <HeaderSearchFilter
        handleChangeFilter={handleChangeFilter}
        search={search}
        filter={filter}
        handleChangeSearch={deboundSearch}
      />
      <ScrollArea className='h-[calc(100vh_-_240px)] overflow-y-auto px-4 lg:h-[600px] lg:px-0'>
        <div className='flex flex-wrap py-4'>
          {isLoading && (
            <>
              <div className='mx-2 mb-2'>
                <div>
                  <Skeleton width={150} height={108} />
                  <Skeleton width={150} height={8} mt={8} />
                  <Skeleton width={100} height={8} mt={8} />
                  <Skeleton width={50} height={8} mt={10} />
                </div>
              </div>
              <div className='mx-2 mb-2'>
                <div>
                  <Skeleton width={150} height={108} />
                  <Skeleton width={150} height={8} mt={8} />
                  <Skeleton width={100} height={8} mt={8} />
                  <Skeleton width={50} height={8} mt={10} />
                </div>
              </div>
            </>
          )}
          {!isLoading && listGift.length > 0 ? <ListGiftCategory listGift={listGift} /> : null}
          {!isLoading && listGift.length === 0 ? (
            <div className='mx-auto'>
              <Empty
                description={
                  isSearching ? 'Không tìm thấy quà' : 'Quà trong danh mục đã sử dụng hết'
                }
              />
            </div>
          ) : null}
        </div>
      </ScrollArea>
      <div className='mx-auto py-8 lg:mt-8 lg:py-0'>
        <Pagination
          style={{
            width: 'fit-content',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          className='custom_pagination'
          pageSize={pagination.pageSize}
          total={pagination.total}
          current={pagination.current}
          onChange={handldePagiantionChange}
          showSizeChanger={true}
        />
      </div>
    </div>
  );
};

export default DetailGiftCategory;
